import _ from 'lodash';
import { connect } from 'react-redux';
import { getHistoricalGasBuddyPrices } from '../../modules/reports/gasBuddyPrices';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	const stationId = parseInt(_.get(ownProps, ['match', 'params', 'stationId']), 10);

	let historicalGasBuddyPrices = undefined;

	if (state.reportsGasBuddyPrices.historicalByStationId[stationId]) {
		historicalGasBuddyPrices = state.reportsGasBuddyPrices.historicalByStationId[stationId];
	}

	return {
		historicalGasBuddyPrices,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
		gasBuddyPriceMap: state.maps.gasBuddyPrice,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getHistoricalGasBuddyPrices,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
